import config from '../../config/environment';
import { apiClient } from './client';

/**
 * API Services Index
 *
 * Re-exports all API-related modules for convenient importing.
 */

export { apiClient, getCsrfToken, setCsrfToken, clearCsrfToken, ApiClient } from './client';
export { ApiRequestError } from './types';
export type { ApiRequestOptions, ApiError, PaginatedResponse, AuditLogEntry, DataSharingInfo } from './types';

export const API_BASE_URL = config.apiUrl;

export function authFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const endpoint = typeof input === 'string' ? input : input.toString();
  return apiClient.requestRaw(endpoint, {
    ...init,
    method: init?.method || 'GET',
    headers: (init?.headers || {}) as Record<string, string>,
    body: init?.body,
  });
}
